import { render, staticRenderFns } from "./mProductCard2.vue?vue&type=template&id=626e76ab&scoped=true"
import script from "./mProductCard2.vue?vue&type=script&lang=js"
export * from "./mProductCard2.vue?vue&type=script&lang=js"
import style0 from "./mProductCard2.vue?vue&type=style&index=0&id=626e76ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e76ab",
  null
  
)

export default component.exports